import { apiClient } from '@/services/api'

// Site playout engine pool + admin CRUD. Engines are sigla-scoped DB rows
// (tab_globographics_site_engine); /playout/engines returns the inventory + current
// allocation (scoped by the x-globographics-site header). Create/update/delete are
// admin-only in the UI; delete is blocked (409 ENGINE_IN_USE) while a production is
// on-air on the engine.

const state = () => ({
    engines: [],
    loading: false,
    lastError: null,
})

const getters = {
    getterEngines: state => state.engines,
    getterEnginesLoading: state => state.loading,
    getterEnginesError: state => state.lastError,
}

function describeError(error, fallback) {
    return error?.response?.data?.error || fallback
}

const actions = {
    async fetchEngines({ commit }) {
        commit('setLoading', true)
        commit('setLastError', null)
        try {
            const { data } = await apiClient.get('playout/engines')
            commit('setEngines', Array.isArray(data) ? data : [])
            return data
        } catch (error) {
            commit('setLastError', describeError(error, 'Erro ao carregar engines'))
            throw error
        } finally {
            commit('setLoading', false)
        }
    },

    // --- Engine CRUD (sigla-scoped via the x-globographics-site header) ---
    async createEngine({ dispatch }, payload) {
        const { data } = await apiClient.post('playout/engines', payload)
        await dispatch('fetchEngines')
        return data
    },
    async updateEngine({ dispatch }, { id, ...payload }) {
        const { data } = await apiClient.put(`playout/engines/${id}`, payload)
        await dispatch('fetchEngines')
        return data
    },
    async deleteEngine({ dispatch }, id) {
        await apiClient.delete(`playout/engines/${id}`)
        await dispatch('fetchEngines')
    },
}

const mutations = {
    setEngines: (state, engines) => { state.engines = engines },
    setLoading: (state, loading) => { state.loading = loading },
    setLastError: (state, msg) => { state.lastError = msg },
}

export default { namespaced: true, state, getters, actions, mutations }
